<template>
  <div class="fm-modal-overlay" @click.self="$emit('cancel')">
    <div class="fm-modal fm-move-modal">
      <h3 class="fm-modal-title">Mover a...</h3>
      <div class="fm-move-tree">
        <FMMoveNode
          :node="{ id: null, name: 'Mi unidad', children: tree }"
          :selected="selected"
          :current-path="currentPath"
          @select="selected = $event"
        />
      </div>
      <div class="fm-modal-actions">
        <button class="fm-btn-cancel" @click="$emit('cancel')">Cancelar</button>
        <button class="fm-btn-confirm" :disabled="!selected" @click="$emit('confirm', selected)">Mover aquí</button>
      </div>
    </div>
  </div>
</template>

<script>
import FMMoveNode from './FMMoveNode.vue'
export default {
  name: 'FMMoveDialog',
  components: { FMMoveNode },
  props: { tree: Array, currentPath: Array },
  data() { return { selected: null } }
}
</script>

<style scoped>
.fm-move-modal { min-width: 340px; }
.fm-move-tree {
  background: var(--fm-surface2); border: 1px solid var(--fm-border);
  border-radius: var(--fm-radius-sm); padding: 8px;
  max-height: 300px; overflow-y: auto; margin-bottom: 4px;
}
.fm-modal-overlay {
  position: fixed; inset: 0;
  background: rgba(20,35,70,0.30); backdrop-filter: blur(4px);
  display: flex; align-items: center; justify-content: center; z-index: 500;
}
.fm-modal {
  background: var(--fm-surface); border: 1px solid var(--fm-border2);
  border-radius: 14px; padding: 24px;
  box-shadow: var(--fm-shadow); animation: fm-pop 0.18s ease;
}
@keyframes fm-pop { from { transform: scale(0.92); opacity: 0; } to { transform: scale(1); opacity: 1; } }
.fm-modal-title { font-size: 16px; font-weight: 600; color: var(--fm-text); margin-bottom: 16px; }
.fm-modal-actions { display: flex; justify-content: flex-end; gap: 8px; margin-top: 16px; }
.fm-btn-cancel {
  background: none; border: 1px solid var(--fm-border2);
  color: var(--fm-text2); font-family: var(--fm-font); font-size: 13px;
  padding: 7px 16px; border-radius: var(--fm-radius-sm); cursor: pointer;
}
.fm-btn-cancel:hover { color: var(--fm-text); }
.fm-btn-confirm {
  background: var(--fm-accent); color: #fff; border: none;
  font-family: var(--fm-font); font-size: 13px; font-weight: 500;
  padding: 7px 16px; border-radius: var(--fm-radius-sm); cursor: pointer;
}
.fm-btn-confirm:disabled { opacity: 0.4; cursor: not-allowed; }
</style>
